.error {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  place-self: center;
  width: 50rem;
  max-width: 60dvw;
  padding: var(--mantine-spacing-xl);
  font-size: var(--mantine-font-size-md);
  color: var(--mantine-color-text);
  background: var(--mantine-color-body);
  h1 {
    margin-block-start: 0;
    font-size: var(--mantine-font-size-xl);
  }
  .location {
    padding-top: var(--mantine-spacing-md);
    margin-top: var(--mantine-spacing-md);
    font-size: var(--mantine-font-size-xs);
    border-top: 1px solid var(--mantine-color-dark-6);
  }
  pre,
  code {
    font-size: 90%;
    color: var(--mantine-color-dimmed);
    background: var(--mantine-color-dark-6);
  }
  pre {
    height: 10rem;
    max-height: 30dvh;
    padding: var(--mantine-spacing-md);
    margin-block-end: 0;
    overflow: auto;
    font-size: calc(var(--mantine-font-size-md) * 0.6);
  }
}
